import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import { initErrorHandlerStore } from '@/services/errorHandler'
import { installProjectDataLoader } from '@/router/installProjectDataLoader'
import './assets/main.css'   // custom CSS only
import 'maplibre-gl/dist/maplibre-gl.css'
import "leaflet/dist/leaflet.css";
import ScioLoader from '@/common/components/loading/ScioLoader.vue'
import ScioProgressLoader from '@/common/components/loading/ScioProgressLoader.vue'
import PublicPageShell from '@/common/components/layout/PublicPageShell.vue'

initErrorHandlerStore(store)
installProjectDataLoader(router, store)

const app = createApp(App)

app.use(router)
app.use(store)
app.component('ScioLoader', ScioLoader)
app.component('ScioProgressLoader', ScioProgressLoader)
app.component('PublicPageShell', PublicPageShell)

app.mount('#app')